const menuBeverages = [
  {
    id: 1,
    name: "Water",
    description: [""],
    price: "$2.08",
  },
  {
    id: 2,
    name: "Soda",
    description: [""],
    price: "$2.60",
  },
  {
    id: 3,
    name: "Orange Juice",
    description: [""],
    price: "$3.12",
  },
  {
    id: 4,
    name: "Yogurt Drink",
    description: [""],
    price: "$3.64",
  },
];

export default menuBeverages;
